import { formatISODateInCETTimezone } from './date';

export function formatMatchDatetime(datetimeStr: string | undefined): string {
  return formatMatchDatetimeWith(datetimeStr, 'dd.MM.yyyy HH:mm');
}

export function formatMatchTime(datetimeStr: string | undefined): string {
  return formatMatchDatetimeWith(datetimeStr, 'HH:mm');
}

function formatMatchDatetimeWith(
  datetimeStr: string | undefined,
  format: string
): string {
  return datetimeStr
    ? `${formatISODateInCETTimezone(datetimeStr, format)} CET`
    : 'TBD';
}
